"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function EmojiFaceIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M12,3.176A8.824,8.824,0,1,0,20.825,12,8.834,8.834,0,0,0,12,3.176Zm0,15.949A7.125,7.125,0,1,1,19.125,12,7.133,7.133,0,0,1,12,19.125Z" }),
        react_1.default.createElement("path", { d: "M8.733,13.5,7.67,14.557a6.13,6.13,0,0,0,8.659.025l-1.058-1.064A4.632,4.632,0,0,1,8.733,13.5Z" }),
        react_1.default.createElement("path", { d: "M9.53,11.519a1.382,1.382,0,1,0-1.381-1.382A1.382,1.382,0,0,0,9.53,11.519Z" }),
        react_1.default.createElement("path", { d: "M14.47,11.519a1.382,1.382,0,1,0-1.382-1.382A1.381,1.381,0,0,0,14.47,11.519Z" })));
}
exports.default = EmojiFaceIcon;
